import QRCode from "qrcode";

export const generateQRBase64 = async (text) => {
  try {
    const qr = await QRCode.toDataURL(text, {
      width: 200,
      margin: 1
    });

    return qr;

  } catch (err) {
    console.error(err);
    return null;
  }
};